import type { dynamicObj } from 'src/pages/assets';
import { useDropdownStore } from 'src/store/Dropdown/dropdown.store';

const dropdown_store = useDropdownStore();
const { getSelectedLanguage } = dropdown_store;

export default {
  methods: {
    validateEmail(email: string): boolean {
      const reg = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/;
      if (!reg.test(email)) return false;
      return true;
    },
    removeClass(element: HTMLElement, className: string) {
      element.classList.remove(className);
    },
    addClass(element: HTMLElement, className: string) {
      element.classList.add(className);
    },
    stringReplaceWithString(
      target: string,
      search: string,
      replacement: string,
    ): string {
      const finalString: string = target.split(search).join(replacement);
      return finalString;
    },
    hasWhiteSpace(str: string) {
      return /\s/g.test(str);
    },
    checkFirstLetterIsSpecialOrNumber(str: string) {
      const spCharsRegExp = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+|^\d/;
      return spCharsRegExp.test(str);
    },
    isDate(dateString: string) {
      return !isNaN(Date.parse(dateString));
    },
    isNumeric(input: string) {
      const result = this.parseUSNumber(input);
      return !isNaN(result);
    },
    parseUSNumber(input: string) {
      if (typeof input !== 'string') return input;
      return Number(input.replace(/,/g, ''));
    },
    scrollInToViewCenter(
      element: HTMLElement,
      position: 'center' | 'nearest' | 'start' | 'end' = 'center',
    ) {
      if (element) {
        element.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: position,
        });
      }
    },
    scrollInToViewStart(element: HTMLElement) {
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    highlightElemet(
      selectedElement: HTMLElement,
      highliteClass: string,
      persistHighlighter = false,
    ) {
      selectedElement.classList.add(highliteClass);
      if (persistHighlighter) {
        return;
      }
      setTimeout(() => {
        selectedElement.classList.remove(highliteClass);
      }, 4000);
    },
    filterByObject(data: dynamicObj[], filter: dynamicObj): dynamicObj[] {
      const result = data.filter((obj: dynamicObj) => {
        return Object.entries(filter).every(([key, value]) => {
          if (value) {
            if (typeof value === 'string') {
              return String(obj[key])
                ?.toLowerCase()
                ?.includes(value?.toLowerCase());
            } else {
              return obj[key].includes(value);
            }
          } else {
            return true;
          }
        });
      });
      return result;
    },
    getNotNullObjectProperties(obj: any) {
      const params = {} as dynamicObj;
      for (const key of Object.keys(obj)) {
        if (obj[key]) {
          params[key] = obj[key];
        }
      }
      return params;
    },
    roundOff(val: any, floatingPoints = 2): any {
      if (!val) {
        return;
      }
      // Convert string to number if possible
      const num = Number(val);

      // Check if it's a valid number and not an integer
      if (!isNaN(num) && !Number.isInteger(num)) {
        return parseFloat(num.toFixed(floatingPoints));
      }

      // Return original value if not a number or if already an integer
      return val;
    },
    getRefElement(refElement: any): any {
      if(refElement && Array.isArray(refElement)) {
          return refElement[0];
      }
      return refElement;
    },

    sortLettersThenNumbers(items: any) {
      const locale = getSelectedLanguage();
      return [...items].sort((a, b) => {
        const valA = a.label;
        const valB = b.label;

        const startsWithLetterA = /^[A-Za-z]/.test(valA);
        const startsWithLetterB = /^[A-Za-z]/.test(valB);

        if (startsWithLetterA && !startsWithLetterB) return -1;
        if (!startsWithLetterA && startsWithLetterB) return 1;

        if (startsWithLetterA && startsWithLetterB) {
          return valA.localeCompare(valB, locale, { numeric: true });
        }

        const matchA = valA.match(/^0*(\d+)/);
        const matchB = valB.match(/^0*(\d+)/);

        if (matchA && matchB) {
          const rawA = matchA[0];
          const rawB = matchB[0];
          const numA = parseInt(matchA[1], 10);
          const numB = parseInt(matchB[1], 10);

          const zerosA = rawA.length - numA.toString().length;
          const zerosB = rawB.length - numB.toString().length;
          if (zerosA !== zerosB) return zerosB - zerosA;
          if (numA !== numB) return numA - numB;

          return valA.localeCompare(valB, locale, { numeric: true });
        }
        return valA.localeCompare(valB, locale, { numeric: true });
      });
    },
  },
};
